import { render, staticRenderFns } from "./areaBox.vue?vue&type=template&id=6f21561e&scoped=true"
import script from "./areaBox.vue?vue&type=script&lang=js"
export * from "./areaBox.vue?vue&type=script&lang=js"
import style0 from "./areaBox.vue?vue&type=style&index=0&id=6f21561e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21561e",
  null
  
)

export default component.exports